<template>
  <b-modal id="editCommitmentStatement" size="xl" hide-footer title="Редактирование шаблона заявления" @hidden="resetModalProps">
    <div id="commitmentStatementContainer"
         style="border: 1px solid black; width: 794px; padding: 55px 37px 55px 55px; margin: auto; position: relative">
      <div>
        <table style="width: 100%">
          <tbody>
          <tr>
            <td style="width: 50%; vertical-align: top;">
              <div class="float-left">
                <ctk-date-time-picker
                  id="reportDatePicker1"
                  v-model="reportDatePickerValue1"
                  style="width: 170px"
                  label="Выберите дату"
                  color="#40b539"
                  locale="ru"
                  format="YYYY-MM-DD"
                  buttonNowTranslation="Сегодня"
                  formatted="LL"
                  onlyDate
                >
                </ctk-date-time-picker>
              </div>
            </td>
            <td style="width: 50%; text-align: right; vertical-align: top; font-size: 13px;">
              <span>Балтийская таможня</span><br><span>т/п Бронка</span></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="font-size: 13px; text-align: center; margin-bottom: 15px;"><b>Заявление-обязательство о временном
        ввозе товаров</b></div>
      <div class="d-flex justify-content-center align-items-center" style="font-size: 13px; margin-bottom: 15px;">
        <div>53/10216160/</div>
        <div>
          <ctk-date-time-picker
            id="reportDatePicker2"
            v-model="reportDatePickerValue1"
            style="width: 170px"
            label="Выберите дату"
            color="#40b539"
            locale="ru"
            format="YYYY-MM-DD"
            buttonNowTranslation="Сегодня"
            formatted="DDMMYY"
            onlyDate
          >
          </ctk-date-time-picker>
        </div>
        <div>/ЗО0____________</div>
      </div>
      <div style="width: 100%; font-size: 13px;">
        Просим Вас разрешить временный ввоз порожних контейнеров, указанных в табл. №1 на территорию Таможенного
        союза, в соответствии с Приложением В.3. к Конвенции о временном ввозе от 26.06.1990 года, с полным
        освобождением от уплаты таможенных платежей.
      </div>
      <div style="margin-bottom: 15px; font-size: 13px; font-style: italic; text-align: right;">Таблица №1</div>
      <div style="margin-bottom: 15px;">
        <table style="font-size: 13px; width: 100%; border: 1px solid black;">
          <thead>
          <th style="padding: 5px; border-right: 1px solid black; text-align: center;">№<br> п/п</th>
          <th style="padding: 5px; border-right: 1px solid black; text-align: center;">Наименование</th>
          <th style="padding: 5px; border-right: 1px solid black; text-align: center;">Кол-во,<br> шт.</th>
          <th style="padding: 5px; border-right: 1px solid black; text-align: center;">Вес, кг</th>
          <th style="padding: 5px; border-right: 1px solid black; text-align: center;">Стоимость,<br> евро</th>
          <th style="padding: 5px; border-right: 1px solid black; text-align: center;">Коносамент</th>
          <th style="padding: 5px; text-align: center;">Судно</th>
          </thead>
        </table>
      </div>
      <div style="font-size: 13px;">Настоящим АО «Контейнершипс Санкт-Петербург» обязуется перед т/п Бронка Балтийской
        таможни возвратить
      </div>
      <div style="font-size: 13px;" class="d-flex justify-content-start align-items-center">
        <div style="font-size: 13px; margin-right: 8px;">товары, указанные в табл.№1 в неизменном состоянии в срок
          до
        </div>
        <div style="font-size: 13px; margin-right: 8px;">
          <ctk-date-time-picker
            id="reportDatePicker3"
            v-model="reportDatePickerValue2"
            style="width: 170px;"
            label="Выберите дату"
            color="#40b539"
            locale="ru"
            format="YYYY-MM-DD"
            buttonNowTranslation="Сегодня"
            formatted="DD/MM/YYYY"
            onlyDate
          >
          </ctk-date-time-picker>
        </div>
        <div style="font-size: 13px;">г.</div>
      </div>
      <div style="font-size: 13px;">
        <p>Контейнеры принадлежат Containerships - CMA-CGM GmbH.</p>
        <p>Об ответственности, установленной КоАП РФ за несоблюдение таможенной процедуры временного ввоза АО
          «Контейнершипс Санкт-Петербург» предупрежден.</p>
        <div>
          <b-form-textarea
            style="font-size: 13px;"
            id="report-signature"
            v-model="reportSignatureText"
            placeholder="Введите текст"
            rows="3"
          ></b-form-textarea>
        </div>
        <div>
          Отметка должностного лица таможенного органа_________________________________________<br>
          Товар соответствует заявленным сведениям
        </div>
      </div>
    </div>
    <div style="text-align: center; margin-top: 15px;">
      <b-button @click="downloadCommitmentStatement" variant="success">
        <div v-if="!busyCommitmentStatement">Сформировать и скачать ЗО</div>
        <div v-else class="d-flex align-items-center justify-content-center">
          <b-spinner small type="grow" label="Загружается..." class="mr-3"></b-spinner><span>Идёт загрузка...</span>
        </div>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import { getCommitmentStatementMixin } from '../mixins/getCommitmentStatementMixin'
  import { mapActions } from 'vuex'
  import html2pdf from './../../../node_modules/html2pdf.js/dist/html2pdf.js'
  import CtkDateTimePicker from 'vue-ctk-date-time-picker'
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
  import moment from 'moment'
  export default {
    name: "EditCommitmentStatement",
    components: {
      CtkDateTimePicker
    },
    mixins: [getCommitmentStatementMixin],
    data () {
      return {
        reportDatePickerValue1: '',
        reportDatePickerValue2: '',
        reportSignatureText: 'С уважением, Зайцев А.И. Руководитель отдела экспедирования и декларирования грузов АО «Контейнершипс Санкт-Петербург»',
        busyCommitmentStatement: false
      }
    },
    methods: {
      moment: function (date) {
        moment.locale('ru')
        return moment(date)
      },
      resetModalProps () {
        this.reportDatePickerValue1 = ''
        this.reportDatePickerValue2 = ''
      },
      downloadPDFCommitmentStatement (pages, opt) {
        const promise = new Promise((resolve) => {
          let worker = html2pdf().set(opt).from(pages[0]).toPdf()
          pages.slice(1).forEach(function (page) {
            worker = worker.get('pdf').then(function (pdf) {
              pdf.addPage()
            }).from(page).toContainer().toCanvas().toPdf()
          })
          worker.save().then(() => {
            resolve()
          })
        })
        promise.then(() => {
          this.$root.$emit('bv::hide::modal', 'editCommitmentStatement', event)
          this.reportDatePickerValue1 = this.moment(new Date()).format('YYYY-MM-DD')
          this.reportDatePickerValue2 = this.moment(new Date()).add(6, 'months').format('YYYY-MM-DD')
          this.busyCommitmentStatement = false
        })
      },
      ...mapActions('packages',
        [
          'getReport4emptycont_new'
        ]
      )
    }
  }
</script>

<style scoped>

</style>
